/**
 * Kudago internationalization wrapper
 * Somewhen it will be full-featured i18n, maybe.
 *
 * @module i18n
 */

const noop = function () {};

/**
 * Use:
 * _('text')
 * _('%s things', 5)
 */
const exports = function (...args) {
  if (args.length > 1) {
    // simple insertion
    if (args[1] instanceof Array) {
      const str = window.gettext.call(this, args[0]);
      return window.interpolate.call(this, str, args[1]);
    }

    const str = window.ngettext.apply(this, args);
    return window.interpolate.call(this, str, [args[args.length - 1]]);
  }

  return (window.gettext || noop).apply(this, args);
};

/* built-in django i18n functions */
/* separate init function is useful for running multiple tests */
exports.init = function () {
  exports.gettext = window.gettext;
  exports.interpolate = window.interpolate;
  exports.ngettext = window.ngettext;
  exports.pgettext = window.pgettext;
  exports.npgettext = window.npgettext;
};
exports.init();

module.exports = exports;
